export default {"src":"/login-app/[GIT_HASH]/_next/static/media/star_double.cf12ccc5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};